module.exports = __webpack_public_path__ + "static/img/6.63e693c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/4/zh/6.png
// module id = 1YYe
// module chunks = 0